var _path, _mask, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProject(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.23478 11.4446V17.4129H1V11.4446H7.23478ZM7.23478 1V6.96834H1V1H7.23478ZM18.1456 1V6.96834H11.9109V1H18.1456Z",
    stroke: "#16151C",
    strokeWidth: 2
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-outside-1_11743_5409",
    maskUnits: "userSpaceOnUse",
    x: 10.6602,
    y: 9.98242,
    width: 9,
    height: 9,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 10.6602,
    y: 9.98242,
    width: 9,
    height: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4682 17.0224V14.5864H12.0602V13.5784H14.4682V11.1424H15.5322V13.5784H17.9402V14.5864H15.5322V17.0224H14.4682Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4682 17.0224V14.5864H12.0602V13.5784H14.4682V11.1424H15.5322V13.5784H17.9402V14.5864H15.5322V17.0224H14.4682Z",
    fill: "#979797"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4682 17.0224H13.4682V18.0224H14.4682V17.0224ZM14.4682 14.5864H15.4682V13.5864H14.4682V14.5864ZM12.0602 14.5864H11.0602V15.5864H12.0602V14.5864ZM12.0602 13.5784V12.5784H11.0602V13.5784H12.0602ZM14.4682 13.5784V14.5784H15.4682V13.5784H14.4682ZM14.4682 11.1424V10.1424H13.4682V11.1424H14.4682ZM15.5322 11.1424H16.5322V10.1424H15.5322V11.1424ZM15.5322 13.5784H14.5322V14.5784H15.5322V13.5784ZM17.9402 13.5784H18.9402V12.5784H17.9402V13.5784ZM17.9402 14.5864V15.5864H18.9402V14.5864H17.9402ZM15.5322 14.5864V13.5864H14.5322V14.5864H15.5322ZM15.5322 17.0224V18.0224H16.5322V17.0224H15.5322ZM15.4682 17.0224V14.5864H13.4682V17.0224H15.4682ZM14.4682 13.5864H12.0602V15.5864H14.4682V13.5864ZM13.0602 14.5864V13.5784H11.0602V14.5864H13.0602ZM12.0602 14.5784H14.4682V12.5784H12.0602V14.5784ZM15.4682 13.5784V11.1424H13.4682V13.5784H15.4682ZM14.4682 12.1424H15.5322V10.1424H14.4682V12.1424ZM14.5322 11.1424V13.5784H16.5322V11.1424H14.5322ZM15.5322 14.5784H17.9402V12.5784H15.5322V14.5784ZM16.9402 13.5784V14.5864H18.9402V13.5784H16.9402ZM17.9402 13.5864H15.5322V15.5864H17.9402V13.5864ZM14.5322 14.5864V17.0224H16.5322V14.5864H14.5322ZM15.5322 16.0224H14.4682V18.0224H15.5322V16.0224Z",
    fill: "#16151C",
    mask: "url(#path-2-outside-1_11743_5409)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProject);
export default __webpack_public_path__ + "static/media/project.4f826054ae00e41beb17a918b83f37cd.svg";
export { ForwardRef as ReactComponent };